import styled, { css } from "styled-components";

import { SWReactCountryIcons } from "@similarweb/icons";

export const StyledDDContainer = styled.div<{ withPadding?: boolean }>`
    position: relative;
    ${({ withPadding }) =>
        withPadding &&
        css`
            & .Popup-content {
                padding-bottom: 138px !important;
            }
        `}
`;

export const StyledHookBanner = styled.div`
    z-index: 11;
    position: absolute;
    bottom: 0;
    width: 502px;
    & > div {
        box-sizing: border-box;
    }
`;

export const StyledCountryIcon = styled(SWReactCountryIcons)`
    line-height: 20px;
    margin-right: 8px;
`;
